import en from './en';
import fr from './fr';
import hk from './hk';
import tw from './tw';
import ja from './ja';
import de from './de';

const languages = {
  en,
  fr,
  hk,
  tw,
  ja,
  de,
};

export default languages; 